import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import './RemoveComparableDialog.scss';
import RemoveComparableDialog from './RemoveComparableDialog';

const mapStateToProps = (state, ownProps) => {

  return {
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const RemoveComparableDialogContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(RemoveComparableDialog);

export { RemoveComparableDialogContainer, RemoveComparableDialog, mapStateToProps };

RemoveComparableDialogContainer.propTypes = {
  onConfirmation: PropTypes.func.isRequired,
};
export default RemoveComparableDialogContainer;